import { render, staticRenderFns } from "./PartnerDetailsPage.vue?vue&type=template&id=a95a0df8&scoped=true"
import script from "./PartnerDetailsPage.vue?vue&type=script&lang=js"
export * from "./PartnerDetailsPage.vue?vue&type=script&lang=js"
import style0 from "./PartnerDetailsPage.vue?vue&type=style&index=0&id=a95a0df8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a95a0df8",
  null
  
)

export default component.exports